var React = require('react');

function Dial180 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1000 999.929L1000 500C1000 223.892 776.108 0 500 0C223.822 0 0 223.892 0 500C0 776.108 223.892 1000 500 1000L1000 999.929Z","fill":"currentColor"}));
}

Dial180.defaultProps = {"width":"1000","height":"1000","viewBox":"0 0 1000 1000","fill":"none"};

module.exports = Dial180;

Dial180.default = Dial180;
